import { Button, Modal } from '@repo/ui';
import { tr } from '@repo/locale';
import type { TestId } from '@repo/test-id';
import { ArrowRightIcon, CarIcon } from '@repo/icons';

interface Props {
  testId: TestId;
  vehicleChangePossible: boolean;
  onChangeVehicle: () => void;
  onAbandon: () => void;
  onDismiss: () => void;
}

export default function ExitModal({ testId, vehicleChangePossible, onChangeVehicle, onAbandon, onDismiss }: Props) {
  const handleOpenChange = (open: boolean) => {
    if (!open) onDismiss();
  };

  return (
    <Modal
      open
      testId={testId}
      title={
        vehicleChangePossible ? tr('reservations:exit.change_vehicle_title') : tr('reservations:exit.abandon_title')
      }
      width="md"
      onOpenChange={handleOpenChange}
      footer={
        <div className="flex gap-2">
          <Button
            testId={testId.append('abandon')}
            label={tr('reservations:exit.abandon')}
            color="danger"
            className="w-full"
            onClick={onAbandon}
          />
          <Button
            testId={testId.append('continue')}
            rightIcon={ArrowRightIcon}
            label={tr('reservations:exit.continue')}
            color="brand"
            className="w-full"
            onClick={onDismiss}
          />
        </div>
      }
    >
      <div className="flex flex-col gap-2 py-4">
        {vehicleChangePossible && (
          <>
            <Button
              testId={testId.append('changeVehicle')}
              label={tr('reservations:exit.change_vehicle')}
              color="secondary"
              leftIcon={CarIcon}
              className="w-full"
              onClick={onChangeVehicle}
            />
            <h2 className="mt-3 text-xl font-medium">{tr('reservations:exit.abandon_title')}</h2>
          </>
        )}
        <div className="space-y-1">
          <div className="text-heading text-base leading-5">{tr('reservations:exit.incomplete')}</div>
          <div className="text-body text-base leading-5 font-light">{tr('reservations:exit.warning')}</div>
          <div className="text-body text-sm leading-5 font-light">{tr('reservations:exit.feedback')}</div>
        </div>
      </div>
    </Modal>
  );
}
